import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getPackingDetailByFulfillment,
  getRemovableItems,
  notifyPartialFulfill,
} from 'features/Order/services/packers'
import { callErrorMsg } from 'helpers/errorMsg'

export const fetchPackingDetail = createAsyncThunk(
  'popupPackingDetail/fetchPackingDetail',
  async (fulfillmentID: string) => {
    try {
      const response = await getPackingDetailByFulfillment(fulfillmentID)
      return {
        ...response.data,
        fulfillment_id: fulfillmentID,
      }
    } catch (error) {
      return callErrorMsg(error)
    }
  },
)

export const fetchPackingDetailRemovable = createAsyncThunk(
  'popupPackingDetail/fetchPackingDetailRemovable',
  async (fulfillmentID: string) => {
    try {
      const response = await getRemovableItems(fulfillmentID)
      return response.data
    } catch (error) {
      return callErrorMsg(error)
    }
  },
)

export const notifyPartialFulfillExtOrder = createAsyncThunk(
  'popupPackingDetail/notifyPartialFulfillExtOrder',
  async (orderID: number, { rejectWithValue }) => {
    try {
      await notifyPartialFulfill(orderID)
      return true
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
